import React from "react";
import ExportPanel from "./ExportPanel";

// Kept as its own component so the boards keep importing what they always did.
// Everything it used to do — file list, options modal, job polling — now lives
// in ExportPanel / useExportJobs, shared with the selected-cards export.
const ExportTable = ({ visible, open, onCancel }) => (
  <ExportPanel open={visible ?? open ?? false} onClose={onCancel} scope="project" />
);

export default ExportTable;
